import {
  CheckCircleIcon,
  ClockIcon,
  
} from "@heroicons/react/24/solid";
import { createColumnHelper } from "@tanstack/react-table";
const columnHelper = createColumnHelper();

export const blogsTableColumnsConfig = (handleNavigateToDetail) => [
  columnHelper.accessor("id", {
    header: "Id",
    cell: (info) => info.getValue(),
    footer: (props) => props.column.id,
  }),
  columnHelper.accessor("title", {
    header: "Title",
    cell: (info) => {
      const value = info.getValue() || "";

      const displayText = value.length > 20 ? `${value.slice(0, 20)}…` : value;

      return <span title={value}>{displayText}</span>;
    },
    footer: (props) => props.column.id,
  }),

  columnHelper.accessor("category", {
    header: "Category",
    cell: (info) => info.getValue(),
    footer: (props) => props.column.id,
  }),
  columnHelper.accessor("status", {
    header: "Status",
    cell: (info) => info.getValue(),
    footer: (props) => props.column.id,
  }),
  columnHelper.accessor("publishing_date", {
    header: "Date",
    cell: (info) => info.getValue(),
    footer: (props) => props.column.id,
  }),
  columnHelper.accessor("is_active", {
  header: "Status",
  cell: ({ getValue }) => {
    const isActive = getValue();

    const config = {
      1: {
        label: "Active",
        bg: "#E6F7EF",
        color: "#00A167",
        Icon: CheckCircleIcon,
      },
      0: {
        label: "Inactive",
        bg: "#F2F2F2",
        color: "#6B7280",
        Icon: ClockIcon,
      },
    }[isActive];

    if (!config) return "-";

    const { label, bg, color, Icon } = config;

    return (
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "6px",
          padding: "4px 10px",
          borderRadius: "999px",
          fontSize: "12px",
          fontWeight: 500,
          backgroundColor: bg,
          color,
          whiteSpace: "nowrap",
        }}
      >
        <Icon style={{ width: 14, height: 14 }} />
        {label}
      </div>
    );
  },
}),


  columnHelper.display({
    id: "actions",
    header: <div style={{ textAlign: "center" }}>Action</div>,
    cell: (props) => (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <button
          style={{
            padding: "6px 12px",
            background: "linear-gradient(135deg, #2F3567 0%, #5561A0 100%)",
            color: "#FFFFFF",
            fontWeight: 500,
            fontSize: "13px",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            transition: "all 0.3s ease",
            boxShadow: "0 2px 6px rgba(47,53,103,0.3)",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background =
              "linear-gradient(135deg, #5561A0 0%, #7B82C0 100%)";
            e.currentTarget.style.boxShadow = "0 4px 12px rgba(47,53,103,0.35)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background =
              "linear-gradient(135deg, #2F3567 0%, #5561A0 100%)";
            e.currentTarget.style.boxShadow = "0 2px 6px rgba(47,53,103,0.3)";
          }}
          onClick={() => handleNavigateToDetail(props.row.original.id)}
        >
          View Details
        </button>
      </div>
    ),
  }),
];
